import { z } from 'zod'

export const adUnitIdsField = z.object({
  adUnitIds: z.array(z.string()),
})
